import React, { FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useElementSize } from 'usehooks-ts'
import { Annotation } from '../Annotation/Annotation'
import { ConnectorType } from '../Connector/Connector'
import { AnchorTypes, AnnotationType } from '../types'

type DefaultsType = {
  content?: React.ReactNode
  anchor?: AnchorTypes
  distance?: number
  Marker?: React.ReactNode
  left?: number
  top?: number
  connect?: boolean
  connector?: Partial<ConnectorType>
}

export interface AnnotationElementProps {
  children?: React.ReactNode
  defaults?: DefaultsType
  annotations?: AnnotationType[]
}
const presets: DefaultsType = {
  anchor: 'top-right',
  distance: 0,
  left: 0,
  top: 0,

  connector: { type: 'straight', style: { stroke: '#000' } },
}
export const AnnotationElement: FC<AnnotationElementProps> = ({
  children,
  annotations,
  defaults = {},
}) => {
  return (
    <AnnotationElementRoot>
      <AnnotationElementContainer>
        {children && children}
      </AnnotationElementContainer>
      <AnnotationContainer className='anno container'>
        {annotations &&
          annotations.map((annotation, i) => {
            const Marker =
              annotation.Marker === false
                ? undefined
                : annotation.Marker || defaults.Marker
            const { left, top, content, anchor, distance, connect, connector } =
              {
                ...presets,
                ...defaults,
                ...annotation,
              }

           
            return (
              <Annotation
                key={'anno_' + i}
                left={left}
                top={top}
                anchor={anchor as AnchorTypes}
                distance={distance}
                connect={connect}
                connector={connector}
                Marker={Marker}
              >
                {content && content}
              </Annotation>
            )
          })}
      </AnnotationContainer>
    </AnnotationElementRoot>
  )
}

const AnnotationElementRoot = styled.div`
max-width: 100%;
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
`
const AnnotationElementContainer = styled.div`
  height: 100%;
`
const AnnotationContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
